import React, {useEffect, useState} from "react";
import { OuterDiv } from "./styles";
import { event } from "react-ga";
import BaseTickBox from "./TickBox";

const BaseTickBoxes = ({attributes, onChange, disabled}) => {
    const [selectValueList, setSelectedValueList] = useState()
    const handleChange = (event, index, attributeName) => {
        const { checked } = event.target;
        const updatedList = {...selectValueList, [attributeName]: checked}
        setSelectedValueList(updatedList)
        onChange(updatedList)
    }
    
    useEffect(()=>{
        const value = attributes.reduce((acc, attribute) => {
            acc[attribute.value] = false;
            return acc;
        }, {});
        setSelectedValueList(value)
    },[attributes])

    return (
        <>
        <OuterDiv>
            {selectValueList &&
                (attributes.map((attribute, index)=>(
                    <>
                    <BaseTickBox
                        fontSize={12}
                        attribute={attribute.label}
                        key ={index}
                        disabled={disabled}
                        selected = {selectValueList[attribute.value]}
                        onChange={(event)=>handleChange(event, index, attribute.value)}
                    />
                    </>
                )))
            }
        </OuterDiv>
        </>
    )
}
export default BaseTickBoxes